import React from "react";

export const WordMark: React.FC<{
  className?: string;
  size?: number | string; // Back-compat: treated as height
  height?: number | string; // Preferred: explicit height
}> = ({
  className,
  size = 48,
  height: heightProp,
}) => {
  // Determine sizing via HEIGHT for consistent pairing with LogoMark
  const h = heightProp ?? size;
  let width: string | undefined = undefined;
  let height: string | undefined = undefined;

  if (typeof h === "number") {
    // Aspect: 1204(w) / 160(h)
    height = `${h}px`;
    width = `${Math.round(h * (1204 / 160))}px`;
  } else if (typeof h === "string" && /^\d+(\.\d+)?(px|em|rem|%)?$/.test(h)) {
    height = h; // Let aspect-ratio derive width
    width = undefined;
  }

  return (
    <span
      className={className}
      style={{
        display: "inline-block",
        width,
        height,
        aspectRatio: "1204 / 160",
      }}
    >
      <svg
        width="1204"
        height="160"
        viewBox="0 0 1204 160"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full"
      >
        <path id="word-mark-C"
          d="M124.601 40.8989C121.021 38.9513 117.149 37.603 112.985 36.8539C108.82 36.1049 104.327 35.7303 99.5053 35.7303H79.7796C71.1587 35.7303 63.5972 37.6404 57.095 41.4607C50.5928 45.2809 45.6614 50.4869 42.3007 57.0786C38.94 63.6704 37.2597 71.3858 37.2597 80.2247V80C37.4058 88.6891 39.1592 96.3296 42.5199 102.921C45.8806 109.513 50.7755 114.719 57.2046 118.539C63.6337 122.36 71.1587 124.27 79.7796 124.27H99.5053C104.766 124.27 109.478 123.82 113.642 122.921C117.806 122.022 121.605 120.674 125.039 118.876C128.473 117.079 131.797 114.757 135.012 111.91L156.052 140.225C151.377 144.719 146.19 148.427 140.491 151.348C134.792 154.27 128.583 156.442 121.861 157.865C115.14 159.288 107.688 160 99.5053 160H79.7796C63.1223 160 48.8029 156.629 36.8214 149.888C24.8398 143.146 15.7075 133.783 9.42451 121.798C3.1415 109.813 0 95.955 0 80.2247V80C0 64.1199 3.1415 50.1498 9.42451 38.0899C15.7075 26.03 24.8398 16.6667 36.8214 10C48.8029 3.33333 63.1223 0 79.7796 0H99.5053C107.25 0 114.482 0.674157 121.204 2.02247C127.925 3.37079 134.208 5.50562 140.053 8.42697C145.897 11.3483 151.231 15.1311 156.052 19.7753L135.012 48.0899C131.651 45.2434 128.181 42.8464 124.601 40.8989Z"
          fill="currentColor"
        />
        <path id="word-mark-O"
          d="M307.686 10C319.521 16.6667 328.727 26.0674 335.302 38.2022C341.877 50.3371 345.165 64.2697 345.165 80V80.2247C345.165 95.955 341.877 109.813 335.302 121.798C328.727 133.783 319.521 143.146 307.686 149.888C295.85 156.629 281.604 160 264.947 160H243.248C226.737 160 212.454 156.629 200.4 149.888C188.345 143.146 179.176 133.783 172.893 121.798C166.61 109.813 163.469 95.955 163.469 80.2247V80C163.469 64.2697 166.61 50.3371 172.893 38.2022C179.176 26.0674 188.345 16.6667 200.4 10C212.454 3.33333 226.737 0 243.248 0H264.947C281.604 0 295.85 3.33333 307.686 10ZM287.85 118.652C294.206 114.906 298.992 109.7 302.206 103.034C305.421 96.367 307.028 88.6891 307.028 80V80.2247C307.028 71.236 305.421 63.4457 302.206 56.8539C298.992 50.2622 294.206 45.0936 287.85 41.3483C281.494 37.603 273.86 35.7303 264.947 35.7303H243.248C234.481 35.7303 226.883 37.603 220.454 41.3483C214.025 45.0936 209.13 50.2622 205.769 56.8539C202.409 63.4457 200.728 71.236 200.728 80.2247V80C200.728 88.6891 202.409 96.367 205.769 103.034C209.13 109.7 214.025 114.906 220.454 118.652C226.883 122.397 234.481 124.27 243.248 124.27H264.947C273.86 124.27 281.494 122.397 287.85 118.652Z"
          fill="currentColor"
        />
        <path id="word-mark-P"
          d="M396.596 81.573H450.951C460.741 81.573 467.937 79.9251 472.54 76.6292C477.143 73.3333 479.444 67.7903 479.444 60V59.7753C479.444 52.4345 477.106 47.0412 472.431 43.5955C467.755 40.1498 460.595 38.427 450.951 38.427H393.966L406.897 25.1685V157.753H369.199V2.24719H450.951C473.015 2.24719 489.526 7.19101 500.485 17.0787C511.444 26.9663 516.923 41.1985 516.923 59.7753V60C516.923 78.5768 511.444 92.809 500.485 102.697C489.526 112.584 473.015 117.528 450.951 117.528H396.596V81.573Z"
          fill="currentColor"
        />
        <path id="word-mark-L"
          d="M576.394 120.674H669.762V157.753H538.477V2.24719H576.394V120.674Z"
          fill="currentColor"
        />
        <path id="word-mark-A"
          d="M826.58 157.753L813.649 127.64H735.841L722.91 157.753H682.582L754.691 2.24719H794.58L866.689 157.753H826.58ZM750.307 94.6067H799.183L774.635 39.7753L750.307 94.6067Z"
          fill="currentColor"
        />
        <path id="word-mark-N"
          d="M884.334 2.24719H918.087L1008.39 99.5506L1005.32 100V2.24719H1042.14V157.753H1008.39L918.306 60.6742L921.375 60.2247V157.753H884.334V2.24719Z"
          fill="currentColor"
        />
        <path id="word-mark-E"
          d="M1204 37.5281H1112.82V62.2472H1193.48V97.5281H1112.82V122.472H1204V157.753H1075.12V2.24719H1204V37.5281Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};
